import styled from 'styled-components';
import {
  lightenDarkenColor,
} from 'components/project/ClerkScreen/shared/utils/styles';

export const Title = styled.h2``;

export const Container = styled.div`
    text-align: center;
`;

export const Link = styled.button`
  width: 80%;
  margin: 10px auto;
  padding: 10px 20px;
  text-align: center;
  font-weight: normal;
  background-color: #931C11;
  border-color: #931C11;
  color: #ffffff;
  align-self: center;
  &:hover {
    background-color: ${lightenDarkenColor('#931C11', 20)};
    color: #ffffff;
  }
  & i {
    color: #ffffff;
    padding-right: 5px;
    font-size: 1em;
  }
`;
